import React, { Component } from "react";
import {
    Modal,
    GET,
    POST,
    PUT,
    DELETE,
    Pagination,
    loading,
    NavbarCustomer,
    t, // นำเข้าฟังก์ชันแปลภาษา
} from "../../components/CustomComponent.js";
import { getProfile } from "../../utils/localStorage";

import { formatNumber } from "../../utils/formatting";
// super_user เห็น asset ของทุกลูกค้า -> โชว์ชื่อลูกค้าบนการ์ดให้แยกออกว่าเป็นของใคร
const isSuperUserView = getProfile()?.user_type === "super_user";

// สไตล์ของแต่ละสถานะ asset (สี border ซ้าย + badge)
const STATUS_STYLE = {
  operational: { border: "#198754", badge: "bg-success-light text-success" },
  pm_due: { border: "#fd7e14", badge: "bg-warning-light text-warning" },
  issue_reported: { border: "#dc3545", badge: "bg-danger-light text-danger" },
};

// ไอคอน + สีพื้นหลังของแต่ละหมวดอุปกรณ์ (เดาจากชื่อ/ยี่ห้อ เพราะฝั่ง backend ไม่ได้เก็บไอคอนไว้)
const ASSET_VISUALS = [
  { match: /chiller/i, icon: "", bg: "#EAF2FF", color: "#3B82F6" },
  { match: /ahu|fan/i, icon: "", bg: "#FFF4E5", color: "#F59E0B" },
  { match: /generator|genset/i, icon: "", bg: "#E8F8EE", color: "#16A34A" },
  { match: /pump|water/i, icon: "", bg: "#F3EEFC", color: "#8B5CF6" },
  { match: /ups|server/i, icon: "", bg: "#EEF0FF", color: "#6366F1" },
];
const DEFAULT_ASSET_VISUAL = { icon: "", bg: "#E6F7FB", color: "#06B6D4" };

const getAssetVisual = (name = "") => {
  const found = ASSET_VISUALS.find((v) => v.match.test(name || ""));
  return found || DEFAULT_ASSET_VISUAL;
};

const formatDate = (dateStr) => {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) return "";
  return date.toLocaleDateString("en-GB", { day: "2-digit", month: "2-digit", year: "numeric" });
};

const formatMonthYear = (dateStr) => {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) return "";
  return date.toLocaleDateString("en-US", { month: "short", year: "numeric" });
};

export default class MyAssets extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter_search: "",

      summary: {
        total_assets: 0,
        under_warranty: 0,
        pm_due_month: 0,
        active_issues: 0
      },

      assets: [],
      count: 0,

      modal_detail: false,
      detail: null,
      detail_loading: false
    };
  }

  async componentDidMount() {
    await this.Get(1);
    loading(false);
  }

  Get = async (page = 1) => {
    loading(true);

    const result = await GET("customer/assets", { page_size: 10, page, data_search: this.state.filter_search || "" });

    if (result?.status === true) {
      const data = result.data || {};
      this.setState({
        assets: Array.isArray(data.assets) ? data.assets : [],
        summary: data.summary || this.state.summary,
        count: result.pagination?.count || 0
      });
    }

    loading(false);
  };

  warrantyLabel = (item) => {
    if (item.warranty_status === "expires_in") {
      return { text: `${t("expires_in")} ${item.warranty_days_remaining} ${t("days")}`, colorClass: "text-warning" };
    }
    if (item.warranty_status === "valid_until") {
      return { text: `${t("valid_until")} ${formatMonthYear(item.warranty_expire_date)}`, colorClass: "text-success" };
    }
    return { text: t("expired"), colorClass: "text-secondary" };
  };

  lastPmLabel = (item) => {
    if (item.has_open_work_order) return t("wo_in_progress");
    if (item.last_pm_date) return formatDate(item.last_pm_date);
    return "-";
  };

  warrantyStatusLabel = (detail) => {
    if (detail?.warranty_status === "expires_in") return { text: t("expiring_soon"), colorClass: "text-warning" };
    if (detail?.warranty_status === "valid_until") return { text: t("active"), colorClass: "text-success" };
    return { text: t("expired"), colorClass: "text-danger" };
  };

  openDetail = async (uid) => {
    this.setState({ modal_detail: true, detail: null, detail_loading: true });

    const result = await GET("customer/assets", { uid });

    this.setState({ detail: result?.status === true ? result.data : null, detail_loading: false });
  };

  closeDetail = () => {
    this.setState({ modal_detail: false, detail: null });
  };

  render() {
    const { summary, assets, filter_search, count, modal_detail, detail, detail_loading } = this.state;

    return (
      <div className="w-100 min-vh-100" style={{ backgroundColor: "#F4F7FE" }}>
        <NavbarCustomer />

        <div className="body p-4 mt-3">
          {/* Header Section */}
          <div className="d-flex justify-content-between align-items-center mb-4">
            <div>
              <h3 className="fw-bold mb-1 text-dark">{t("my_assets")}</h3>
              <div className="text-secondary text-14">{t("my_assets_desc")}</div>
            </div>
            <div className="d-flex gap-2">
              <div className="position-relative wpx-300">
                <span className="icon position-absolute top-50 start-0 translate-middle-y ms-3 text-secondary text-12">{""}</span>
                <input
                  type="text"
                  className="form-control ps-5 rounded-4 border-0 shadow-sm bg-white"
                  placeholder={t("search_assets")}
                  value={filter_search}
                  onChange={(e) => this.setState({ filter_search: e.target.value })}
                  onKeyUp={(e) => e.key === "Enter" && this.Get()}
                />
              </div>
              <button className="btn btn-secondary rounded-4 px-3 fw-bold shadow-sm" onClick={() => this.Get(1)}>
                {t("search")}
              </button>
              <button
                className="btn btn-white bg-white border-0 shadow-sm rounded-4 px-3 fw-bold text-dark"
                onClick={() => this.setState({ filter_search: "" }, () => this.Get(1))}
              >
                {t("clear_all")}
              </button>
            </div>
          </div>

          {/* Top Summary Stats Cards */}
          <div className="row g-3 mb-4">
            <div className="col">
              <div className="card border-0 rounded-4 shadow-sm p-3 bg-white h-100">
                <div className="text-secondary text-12 fw-bold mb-1">{t("total_assets")}</div>
                <h3 className="fw-bold mb-0 text-dark">{formatNumber(summary.total_assets)}</h3>
              </div>
            </div>
            <div className="col">
              <div className="card border-0 rounded-4 shadow-sm p-3 bg-white h-100">
                <div className="text-secondary text-12 fw-bold mb-1">{t("under_warranty")}</div>
                <h3 className="fw-bold mb-0 text-success">{formatNumber(summary.under_warranty)}</h3>
              </div>
            </div>
            <div className="col">
              <div className="card border-0 rounded-4 shadow-sm p-3 bg-white h-100">
                <div className="text-secondary text-12 fw-bold mb-1">{t("pm_due_month")}</div>
                <h3 className="fw-bold mb-0 text-warning">{formatNumber(summary.pm_due_month)}</h3>
              </div>
            </div>
            <div className="col">
              <div className="card border-0 rounded-4 shadow-sm p-3 bg-white h-100">
                <div className="text-secondary text-12 fw-bold mb-1">{t("active_issues")}</div>
                <h3 className="fw-bold mb-0 text-danger">{formatNumber(summary.active_issues)}</h3>
              </div>
            </div>
          </div>

          {/* Asset Grid Layout */}
          {assets.length === 0 ? (
            <div className="card border-0 rounded-4 shadow-sm bg-white p-5 text-center text-secondary">
              {t("no_data")}
            </div>
          ) : (
            <div className="row g-4">
              {assets.map((item) => {
                const style = STATUS_STYLE[item.status] || STATUS_STYLE.operational;
                const visual = getAssetVisual(item.name);
                const warranty = this.warrantyLabel(item);

                return (
                  <div key={item.uid} className="col-lg-4 col-md-6">
                    <div
                      className="card border-0 rounded-4 shadow-sm h-100 bg-white transition-hover overflow-hidden pointer"
                      style={{ borderTop: `4px solid ${style.border}` }}
                      onClick={() => this.openDetail(item.uid)}
                    >
                      <div className="p-4">
                        <div className="d-flex justify-content-between align-items-start mb-4">
                          <div className="d-flex align-items-center">
                            <div
                              className="wpx-40 hpx-40 rounded d-flex align-items-center justify-content-center text-20 icon me-3"
                              style={{ backgroundColor: visual.bg, color: visual.color }}
                            >
                              {visual.icon}
                            </div>
                            <div>
                              <h6 className="fw-bold text-dark mb-0">{item.name}</h6>
                              <div className="text-secondary text-12">{item.brand}</div>
                            </div>
                          </div>
                          <span className="icon text-secondary pointer text-14">{""}</span>
                        </div>

                        <div className="d-flex flex-column gap-2 mb-4">
                          {isSuperUserView && (
                            <div className="d-flex justify-content-between text-13">
                              <span className="text-secondary">{t("customer")}</span>
                              <span className="text-dark fw-bold">{item.customer_name || "-"}</span>
                            </div>
                          )}
                          <div className="d-flex justify-content-between text-13">
                            <span className="text-secondary">{t("serial_number")}</span>
                            <span className="text-dark fw-bold">{item.serial_number || "-"}</span>
                          </div>
                          <div className="d-flex justify-content-between text-13">
                            <span className="text-secondary flex-shrink-0 me-2">{t("location")}</span>
                            <span className="text-dark text-truncate d-inline-block" style={{ maxWidth: "65%" }} title={item.location || "-"}>
                              {item.location || "-"}
                            </span>
                          </div>
                          <div className="d-flex justify-content-between text-13">
                            <span className="text-secondary">{t("warranty")}</span>
                            <span className={`fw-bold ${warranty.colorClass}`}>{warranty.text}</span>
                          </div>
                        </div>

                        <hr className="text-light my-3" />

                        <div className="d-flex justify-content-between align-items-center mt-3">
                          <span className={`badge ${style.badge} rounded-pill px-3 py-1 fw-bold text-10`}>
                            {t(item.status)}
                          </span>
                          <div className="text-end">
                            <div className="text-secondary" style={{ fontSize: '10px' }}>{t("last_pm")}:</div>
                            <div className="text-secondary fw-bold text-12">{this.lastPmLabel(item)}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}

          {/* Footer Pagination */}
          {count > 0 && (
            <div className="d-flex justify-content-between align-items-center mt-4 p-3 text-secondary text-12 bg-white rounded-4 shadow-sm">
              <div>
                Showing {assets.length} of {formatNumber(count)} assets
              </div>
              <Pagination className="mb-0" count={Math.ceil(count / 10) || 1} showFirstButton={false} showLastButton={false} onChange={(_, page) => this.Get(page)} />
            </div>
          )}
        </div>

        {/* Asset Details Modal */}
        <Modal show={modal_detail} onHide={this.closeDetail} size="lg" centered>
          <Modal.Header className="border-0 pb-2">
            <Modal.Title className="fw-bold">{t("asset_details")}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {!detail_loading && !detail ? (
              <div className="text-center text-secondary py-5">{t("no_data")}</div>
            ) : detail ? (
              <>
                <div className="d-flex align-items-center mb-4">
                  <div
                    className="rounded-3 d-flex align-items-center justify-content-center text-24 icon me-3 flex-shrink-0"
                    style={{ width: "70px", height: "70px", backgroundColor: getAssetVisual(detail.name).bg, color: getAssetVisual(detail.name).color }}
                  >
                    {getAssetVisual(detail.name).icon}
                  </div>
                  <div>
                    <h5 className="fw-bold text-dark mb-0">{detail.name}</h5>
                    <div className="text-secondary text-13">
                      {[detail.brand, detail.model].filter(Boolean).join(" ")}
                      {detail.serial_number ? ` | ${t("serial_number")}: ${detail.serial_number}` : ""}
                    </div>
                  </div>
                </div>

                <div className="row g-3 mb-4">
                  <div className="col-md-6">
                    <div className="bg-light rounded-4 p-3 h-100">
                      <div className="fw-bold text-dark mb-3">{t("general_information")}</div>
                      <div className="d-flex justify-content-between text-13 mb-2">
                        <span className="text-secondary">{t("material_group")}</span>
                        <span className="text-dark fw-bold">{detail.model || "-"}</span>
                      </div>
                      <div className="d-flex justify-content-between text-13 mb-2">
                        <span className="text-secondary">{t("material_type")}</span>
                        <span className="text-dark fw-bold">{detail.brand || "-"}</span>
                      </div>
                      <div className="d-flex justify-content-between text-13 mb-2">
                        <span className="text-secondary">{t("serial_number")}</span>
                        <span className="text-dark fw-bold">{detail.serial_number || "-"}</span>
                      </div>
                      <div className="d-flex justify-content-between text-13">
                        <span className="text-secondary">{t("install_date")}</span>
                        <span className="text-dark fw-bold">{formatDate(detail.install_date) || "-"}</span>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="bg-light rounded-4 p-3 h-100">
                      <div className="fw-bold text-dark mb-3">{t("warranty_status")}</div>
                      <div className="d-flex justify-content-between text-13 mb-2">
                        <span className="text-secondary">{t("status")}</span>
                        <span className={`fw-bold ${this.warrantyStatusLabel(detail).colorClass}`}>{this.warrantyStatusLabel(detail).text}</span>
                      </div>
                      <div className="d-flex justify-content-between text-13 mb-2">
                        <span className="text-secondary">{t("expiry_date")}</span>
                        <span className="text-dark fw-bold">{formatDate(detail.warranty_expire_date) || "-"}</span>
                      </div>
                      <div className="d-flex justify-content-between text-13">
                        <span className="text-secondary">{t("coverage")}</span>
                        <span className="text-dark fw-bold">{detail.warranty_coverage || "-"}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="fw-bold text-dark mb-2">{t("service_history")}</div>
                {!detail.service_history?.length ? (
                  <div className="bg-light rounded-4 p-3 text-secondary text-13">{t("no_service_history")}</div>
                ) : (
                  <div className="d-flex flex-column gap-2">
                    {detail.service_history.map((h) => (
                      <div key={h.uid} className="d-flex align-items-center bg-light rounded-4 p-3">
                        <div className="wpx-32 hpx-32 rounded-circle bg-success-light text-success d-flex align-items-center justify-content-center me-3 icon flex-shrink-0">
                          {"\uf00c"}
                        </div>
                        <div>
                          <div className="fw-bold text-dark text-14">{h.title}</div>
                          <div className="text-secondary text-12">
                            {formatDate(h.date)}
                            {h.technician_name ? ` - ${h.technician_name}` : ""}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </>
            ) : null}
          </Modal.Body>
          <Modal.Footer className="border-0">
            <button className="btn btn-white border px-3 py-2 fw-bold rounded-3" onClick={this.closeDetail}>
              {t("cancel")}
            </button>
            <button className="btn btn-success px-3 py-2 fw-bold rounded-3" onClick={() => { window.location.href = "/cs/work-requests"; }}>
              {t("create_service_request")}
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
